export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11155.3ec4984a.jpg";